import React from "react";

const NoAuth = () => {
  return <div>NoAuth</div>;
};

export default NoAuth;
